<template>
  <div v-if="roles.length" class="roles-to-text">
    <span v-for="(role, index) in roles" :key="index" class="roles-to-text__role">
      {{roleToText(role)}}<span v-if="index + 1 < roles.length">,&nbsp;</span>
    </span>
  </div>
</template>
<script>
  import {
    USER_ROLE_ADMIN,
    USER_ROLE_ADMIN_LABEL,
    USER_ROLE_MAILING,
    USER_ROLE_MAILING_LABEL,
    USER_ROLE_STATS,
    USER_ROLE_STATS_LABEL,
    USER_ROLE_STUD,
    USER_ROLE_STUD_LABEL,
    USER_ROLE_WIKI,
    USER_ROLE_WIKI_LABEL,
    USER_ROLE_STUDAUTH,
    USER_ROLE_STUDAUTH_LABEL,
    USER_ROLE_CHAT,
    USER_ROLE_CHAT_LABEL,
    USER_ROLE_STUDREMOVE,
    USER_ROLE_STUDREMOVE_LABEL
  } from '@/constants';

  export default {
    props: {
      roles: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      roleToText (role) {
        switch (role) {
          case USER_ROLE_ADMIN:
            return USER_ROLE_ADMIN_LABEL;
            break;
          case USER_ROLE_MAILING:
            return USER_ROLE_MAILING_LABEL;
            break;
          case USER_ROLE_STATS:
            return USER_ROLE_STATS_LABEL;
            break;
          case USER_ROLE_STUD:
            return USER_ROLE_STUD_LABEL;
            break;
          case USER_ROLE_WIKI:
            return USER_ROLE_WIKI_LABEL;
            break;
          case USER_ROLE_STUDAUTH:
            return USER_ROLE_STUDAUTH_LABEL;
            break;
          case USER_ROLE_STUDREMOVE:
            return USER_ROLE_STUDREMOVE_LABEL;
            break;
          case USER_ROLE_CHAT:
            return USER_ROLE_CHAT_LABEL;
            break;
          default:
            return '';
        }
      }
    }
  }
</script>
<style lang="scss">
.roles-to-text {
  display: inline-block;
}
</style>